import { styled, Typography, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { colors } from '@/themesConfig/colors';

export const AuthFormContent = styled('div')({
  display: 'grid',
  gridTemplateRows: '1fr 4fr',
  width: 'clamp(50%, 500px, 90%)',
});

export const AuthFormTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  marginInline: 'auto',
  lineHeight: 1.75,
  fontWeight: 700,
  textAlign: 'center',

  [theme.breakpoints.down('laptop')]: {
    lineHeight: 1.5,
  },

  [theme.breakpoints.down('mobile')]: {
    lineHeight: 1.25,
  },
}));

AuthFormTitle.defaultProps = {
  variant: 'h4',
};

export const AuthFormDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(3, 0),
  color: colors.shuttleGray,

  [theme.breakpoints.down('mobile')]: {
    '& > *': {
      display: 'none',
    },
  },

  '&:before, &:after': {
    top: 0,
  },
}));

export const useStyles = makeStyles(
  (theme) => ({
    form: {
      display: 'flex',
      flexDirection: 'column',
    },

    continueButton: {
      marginTop: theme.spacing(4),

      [theme.breakpoints.down('laptop')]: {
        marginTop: theme.spacing(2),
      },

      [theme.breakpoints.down('mobile')]: {
        padding: theme.spacing(1.5, 3),
        marginTop: theme.spacing(2),
      },
    },
  }),
  {
    name: 'AuthForms',
  },
);
